/* eslint-disable no-plusplus */
import React from 'react'
import moment from 'moment'
import { Popup, Button } from 'semantic-ui-react'
import firebase from 'firebase/app'
import map from 'lodash/map'
import size from 'lodash/size'

class SwitchOperator extends React.Component {
  state = {
    switching: false,
    visible: false,
  }

  switchOperator = async targetOperator => {
    const { order } = this.props
    const now = Number(moment().format('x'))

    try {
      this.setState({ switching: true })

      const orderUpdates = {
        [`orders/${order.key}/operators/${now}`]: targetOperator.uid,
        [`orders/${order.key}/current_operator`]: targetOperator.uid,
      }

      const operatorUpdates = {
        last_order_at: now,
        pending_order_count: targetOperator.pending_order_count,
      }

      const orderRef = firebase
        .database()
        .ref()
        .update(orderUpdates)
      const operatorRef = firebase
        .firestore()
        .collection('dashboard_users')
        .doc(targetOperator.uid)
        .update(operatorUpdates)

      await Promise.all([operatorRef, orderRef])

      alert(`Current order is successfully switch to ${targetOperator.username}`)
    } catch (error) {
      alert(error.message || error)
    } finally {
      this.setState({ switching: false, visible: false })
    }
  }

  onPopupAction = () => {
    const { visible } = this.state

    this.setState({ visible: !visible })
  }

  render() {
    const { order, operators, readOnly } = this.props
    const { switching, visible } = this.state
    let orderNo = 0

    return (
      <Popup
        wide
        hoverable
        hideOnScroll
        open={visible}
        position="bottom center"
        onOpen={this.onPopupAction}
        onClose={this.onPopupAction}
        trigger={
          <Button
            size="tiny"
            icon="exchange"
            loading={switching}
            disabled={switching}
            basic={size(order.operators) === 1}
            color={size(order.operators) === 1 ? 'orange' : 'red'}
          />
        }
      >
        {size(order.operators) > 0 &&
          map(order.operators, (operatorUid, timestamp) => {
            const operator = operators[operatorUid] || {}

            return (
              <div key={timestamp} style={{ marginBottom: 3 }}>
                <p>
                  {++orderNo}. {operator.username}
                </p>
              </div>
            )
          })}
        <hr />
        {map(operators, (operator, operatorUid) => {
          if (operatorUid === order.current_operator || !operator.online) return null

          return (
            <div key={operatorUid} style={{ marginBottom: 3 }}>
              <Button size="tiny" fluid onClick={() => this.switchOperator(operator)} disabled={!!readOnly}>
                {operator.username}
              </Button>
            </div>
          )
        })}
      </Popup>
    )
  }
}

export default SwitchOperator



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/ActionButtons/SwitchOperator.js